import * as React from 'react'
import { PropsWithChildren, ReactElement, useEffect, useState } from 'react'
import { css, getTheme, Icon, mergeStyleSets, Stack, StackItem, Text } from '@fluentui/react'

type Props = PropsWithChildren<{
    legend: string
    canToggle?: boolean
    open?: boolean
}>

const theme = getTheme()
const styles = mergeStyleSets({
    link: {
        userSelect: 'none',
        color: theme.semanticColors.link,
        cursor: 'pointer',
        selectors: {
            '&:hover': { color: theme.semanticColors.linkHovered },
        },
    },
    legend: {
        userSelect: 'none',
        color: 'inherit',
    },
})

const Legend = (props: Props & { toggle: () => void }): ReactElement => {
    if (!props.canToggle) {
        return (
            <Text variant="large" className={css(styles.legend)}>
                {props.legend}
            </Text>
        )
    }

    return (
        <Stack
            horizontal
            verticalAlign="baseline"
            tokens={{ childrenGap: 's1' }}
            onClick={props.toggle}
            className={css(styles.link)}
        >
            <Icon iconName={props.open ? 'ChevronDown' : 'ChevronRight'} />
            <Text variant="large" className={css(styles.legend)}>
                {props.legend}
            </Text>
        </Stack>
    )
}

export default function Fieldset(props: Props): ReactElement {
    const [open, toggle] = useState(props.open ?? !props.canToggle)
    useEffect(() => {
        toggle(props.open ?? !props.canToggle)
    }, [props.open, props.canToggle])

    return (
        <Stack tokens={{ childrenGap: 's2' }}>
            <StackItem>
                <Legend {...props} open={open} toggle={() => toggle(!open)} />
            </StackItem>
            <Stack style={{ display: open ? 'block' : 'none' }} tokens={{ childrenGap: 's2' }}>
                {props.children}
            </Stack>
        </Stack>
    )
}
